import {ValueObject} from '@s-ui/domain'

import {IdSharedValueObject} from '../../shared/ValueObjects/IdSharedValueObject.js'
import {SellerErrorsFactory} from '../Errors/factory.js'
import {BuyerIntentionsSellerValueObject} from '../ValueObjects/BuyerIntentionsSellerValueObject.js'
import {ContactEnrichmentSellerValueObject} from '../ValueObjects/ContactEnrichmentSellerValueObject.js'
import {SubscriptionCommitmentSellerValueObject} from '../ValueObjects/SubscriptionCommitmentSellerValueObject.js'

export class ContactSellerRequest extends ValueObject {
  #adId
  #captchaToken
  #contractId
  #config
  #name
  #email
  #phone
  #message
  #zipCode
  #hasAcceptedTermsAndConditions
  #enrichment
  #subscriptionCommitment

  constructor({
    adId,
    captchaToken,
    config,
    contractId,
    name,
    email,
    phone,
    message,
    zipCode,
    hasAcceptedTermsAndConditions,
    enrichment,
    subscriptionCommitment
  }) {
    super()
    this.#adId = adId
    this.#captchaToken = captchaToken
    this.#config = config
    this.#contractId = contractId
    this.#name = name
    this.#email = email
    this.#phone = phone
    this.#message = message
    this.#zipCode = zipCode
    this.#hasAcceptedTermsAndConditions = hasAcceptedTermsAndConditions
    this.#enrichment = enrichment
    this.#subscriptionCommitment = subscriptionCommitment
      ? SubscriptionCommitmentSellerValueObject.create(subscriptionCommitment)
      : null
  }

  static validate({config, name, email, phone, hasAcceptedTermsAndConditions}) {
    const errors = []
    if (!name?.length) errors.push(SellerErrorsFactory.emptyNameSellerError())
    if (!email?.length) errors.push(SellerErrorsFactory.emptyEmailSellerError())

    const emailRegex = config.get('REGEX_EMAIL')
    const isValidEmail = email?.match(emailRegex)
    if (!isValidEmail) errors.push(SellerErrorsFactory.invalidEmailSellerError())

    if (!hasAcceptedTermsAndConditions) errors.push(SellerErrorsFactory.termsAndConditionsNotAcceptedSellerError())

    if (phone?.length) {
      const phoneRegex = config.get('REGEX_PHONE')
      const isValidPhone = phone.match(phoneRegex)
      if (!isValidPhone) errors.push(SellerErrorsFactory.invalidPhoneSellerError())
    }

    if (errors.length > 0) throw SellerErrorsFactory.contactValidationSellerError({errors})
  }

  static create({
    adId,
    captchaToken,
    config,
    contractId,
    name,
    email,
    phone,
    message,
    zipCode,
    hasAcceptedTermsAndConditions,
    buyerIntentions,
    isDefaultMessage,
    subscriptionCommitment
  }) {
    ContactSellerRequest.validate({
      config,
      name,
      email,
      phone,
      hasAcceptedTermsAndConditions
    })

    return new ContactSellerRequest({
      ...(adId && {adId: IdSharedValueObject.createFromPrimitives({id: adId})}),
      captchaToken,
      config,
      contractId,
      name,
      email,
      phone,
      message,
      zipCode,
      hasAcceptedTermsAndConditions,
      enrichment: ContactEnrichmentSellerValueObject.create({
        buyerIntentions: BuyerIntentionsSellerValueObject.create({buyerIntentions}),
        isDefaultMessage
      }),
      subscriptionCommitment
    })
  }

  getAdId() {
    return this.#adId
  }

  getCaptchaToken() {
    return this.#captchaToken
  }

  getContractId() {
    return this.#contractId
  }

  getEmail() {
    return this.#email
  }

  getMessage() {
    return this.#message
  }

  getName() {
    return this.#name
  }

  getPhone() {
    return this.#phone
  }

  getZipCode() {
    return this.#zipCode
  }

  getEnrichment() {
    return this.#enrichment.getEnrichment()
  }

  getPreferences() {
    if (!this.#subscriptionCommitment) return undefined
    return {
      subscription: {
        commitment: this.#subscriptionCommitment.getCommitment()
      }
    }
  }
}
